// extracted by mini-css-extract-plugin
export default {"section3":"Section3_section3__muCpy","txtBox":"Section3_txtBox__cmQFz"};